module.exports = __webpack_public_path__ + "media/static/logos/apple-logo--white-59f01096ca573a105720e50df1e08e50.svg";